import PropTypes from 'prop-types';
import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import Link from '@nubank/nuds-web/components/Link/Link';

const NavigationListLink = styled(Link)`
  font-family: Graphik-Medium,'Graphik-Regular','Gotham SSm A','Gotham SSm B','Helvetica Neue',Helvetica,Arial,sans-serif;
  font-weight: 500;
  display: flex;
  position: relative;
  width: auto;
  align-items: center;
  ${({ pointerEventsNone }) => pointerEventsNone && 'pointer-events: none;'}

  &:hover {
    text-decoration: none;
    background: none;
  }

  &:focus {
    text-decoration: none;
    background: none;
    outline-width: 0;
  }

  &.menu-navigation-link--large-screen__active {
    &:after {
      content: '';
      position: absolute;
      bottom: -7px;
      left: 50%;
      display: block;
      width: 4px;
      height: 4px;
      border-radius: 10px;
      background-color: ${nuDSColor('primary')};
    }
  }

  svg {
    cursor: pointer;
    box-sizing: border-box;
    vertical-align: bottom;
    will-change: transform;
    transform: rotate( -360deg );            
    transition: transform 150ms ease;
  }
`;

NavigationListLink.defaultProps = {
  typographyProps: {
    variant: 'subtitle2',
    color: 'black',
  },
  href: '/',
  pointerEventsNone: false,
};

NavigationListLink.propTypes = {
  pointerEventsNone: PropTypes.bool,
};

NavigationListLink.displayName = 'NavigationListLink';

export default NavigationListLink;
